import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { LessonSection } from '@/Module/Lesson/Component';
import { lessonSectionSelectIds } from '@/Module/Lesson/Store/Selector';
import { lessonSectionNextPageAction } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const LessonSectionList: FC = () => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(lessonSectionSelectIds);
  const isLoading = useAppSelector(state => state.lessonSection.isLoading);
  const total = useAppSelector(state => state.lessonSection.total);
  const showMore = total > ids.length;
  const onNextClick = () => {
    dispatch(lessonSectionNextPageAction());
  };

  // TODO implement empty list
  if (!ids.length) return null;
  return <>
      <div className="sm:grid:8 mb-7 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:mb-16 lg:grid-cols-3 lg:gap-10 xl:grid-cols-4">
        {ids.map((id, index) => <LessonSection id={id} key={id} index={index + 1} isSummary />)}
      </div>

      {showMore && <div className="mb-12 flex justify-center lg:mb-20">
          <Button isLoading={isLoading} onClick={onNextClick} className="w-full md:w-auto" variant="shadow" color="orange" radius="circle" size="large" bold>
            نمایش بیشتر
          </Button>
        </div>}
    </>;
};
export default LessonSectionList;